import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Settings} from '../../settings/settings';
import {LocalStorage} from '../../utils/storage';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-codalt-image',
    templateUrl: './codalt-image.component.html',
    styleUrls: ['./codalt-image.component.scss']
})
export class CodaltImageComponent implements OnInit, OnChanges {

    @Input() thumb: string;
    @Input() base64: string;
    @Input() icon: string;
    @Input() iconBackground: string;
    @Input() fit: 'cover' | 'contain' | 'natural' = 'cover';
    @Input() url: string;
    @Input() showLogo = true;

    image: string;
    Settings = Settings;

    constructor() {
    }

    ngOnInit() {
        this.setImage();
    }

    setImage() {
        this.image = this.getImagePath();
    }

    ngOnChanges() {
        this.setImage();
    }

    getImagePath() {
        if (this.url) {
            return `${environment.apiEndpoint}api/${this.url}?access_token=${LocalStorage.userToken}`;
        }
        return null;
    }
}
